import PersonIcon from "@mui/icons-material/Person";
import { Box, Stack, Typography } from "@mui/material";

interface Props {
  shipment: ShipperCondensedShipment | undefined;
}

export function CustomerInformationSection(props: Props) {
  const { shipment } = props;

  const customerRoles = shipment?.supplier_shipment_info?.customer_roles ?? [];
  const externalCustomers =
    shipment?.supplier_shipment_info?.external_customers ?? [];

  // Only render if shipment has supplier shipment info with customer roles or external customers
  if (customerRoles.length === 0 && externalCustomers.length === 0) {
    return null;
  }

  return (
    <Box>
      <Stack direction="column" spacing={2}>
        <Typography variant="h6">Customer</Typography>

        <Stack direction="column" spacing={1}>
          {customerRoles.map((role) => (
            <Stack
              key={`role-${role.id}`}
              direction="row"
              alignItems="flex-start"
              spacing={1}
            >
              <PersonIcon color="primary" fontSize="small" sx={{ mt: 0.5 }} />
              <Stack direction="column">
                <Typography variant="body1">
                  {role.user.first_name} {role.user.last_name}
                  {role.company?.name && (
                    <Typography
                      component="span"
                      variant="body2"
                      color="text.secondary"
                    >
                      {" "}
                      ({role.company.name})
                    </Typography>
                  )}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {role.user.email}
                </Typography>
              </Stack>
            </Stack>
          ))}
          {externalCustomers.map((customer) => (
            <Stack
              key={`external-${customer.id}`}
              direction="row"
              alignItems="flex-start"
              spacing={1}
            >
              <PersonIcon color="primary" fontSize="small" sx={{ mt: 0.5 }} />
              <Stack direction="column">
                <Typography variant="body1">
                  {customer.first_name} {customer.last_name}
                  {customer.company_name && (
                    <Typography
                      component="span"
                      variant="body2"
                      color="text.secondary"
                    >
                      {" "}
                      ({customer.company_name})
                    </Typography>
                  )}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {customer.email}
                </Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}
